<section class="header-img-wrapper">
    <div class="container-full-img">

        <picture>
            <source media="(min-width: 992px)" srcset="/assets/img/home/seebensee.jpg">
            <source media="(min-width: 480px)" srcset="assets/img/header/md/seebensee.png">
            <source media="(min-width: 0px)" srcset="assets/img/header/sm/seebensee.png">
            <img class="img-responsive" src="/assets/img/home/seebensee.jpg"
                 alt="Alexander Koenig">
        </picture>
    </div>
    <article class="container-full">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-md-6">
                    <div class="container-full-content">
                        <h2 class="headline-special">Die faszinierende Welt der Fotografie...</h2>
                        <p>Schon immer wollte ich die Geschichten hinter den perfekten Momenten festhalten.<br/>Vor
                            einigen Jahren habe ich mich verstärkt auf die Fotografie fokusiert, um den perfekten Moment
                            festzuhalten...</p>
                    </div>
                </div>
            </div>
        </div>
    </article>
</section>
<section id="wrapper" class="container content-wrapper">

    <article class="row">
        <div class="col-xs-12">
            <h1 class="headline">Fotografie</h1>
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-architecture">
                        <a routerLink="/photography/architecture">
                            <h2>Architektur</h2>
                        </a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-landscape">
                        <a routerLink="/photography/landscape">
                            <h2>Landschaft</h2>
                        </a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-sailing">
                        <a routerLink="/photography/sailing">
                            <h2>Segeln</h2>
                        </a>
                    </article>
                </div>

<!--
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-photography">
                        <a routerLink="/photography/sport">
                            <h2>Sport</h2>
                        </a>
                    </article>
                </div>-->
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-garmisch">
                        <a routerLink="/photography/weltcup">
                            <h2>Ski Weltcup</h2>
                        </a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <article class="m-tsr tsr-local">
                        <a routerLink="/photography/local">
                            <h2>Lokales</h2>
                        </a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <article class="m-tsr tsr-event">
                        <a routerLink="/photography/event">
                            <h2>Events</h2>
                        </a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <article class="m-tsr tsr-muenchner-sommernachtstraum">
                        <a routerLink="/photography/muenchner_sommernachtstraum">
                            <h2>Münchner- Sommernachtstraum</h2>
                        </a>
                    </article>
                </div>
                <!--
                <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-event">
                        <a routerLink="/photography/event">
                            <h2>Event</h2>
                        </a>
                    </article>
                </div> <div class="col-xs-12 col-sm-6 col-md-4">

                    <article class="m-tsr tsr-event">
                        <a routerLink="/photography/ontheway">
                            <h2>Die Welt entdecken</h2>
                        </a>
                    </article>
                </div>-->
            </div>
        </div>
    </article>
</section>
